module.exports = __webpack_public_path__ + "img/integral.0c8325fd.svg";